
import { Injectable } from '@angular/core';
import { AngularFirestore, DocumentReference, DocumentSnapshot } from '@angular/fire/compat/firestore';
import { BehaviorSubject, Observable, forkJoin, of } from 'rxjs';
import { catchError, finalize, map, switchMap, take } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
function _window(): any {
  // return the global native browser window object
  return window;
}

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private userDataSubject: BehaviorSubject<any>;
  constructor(private firestore: AngularFirestore, private http: HttpClient) {
    const storedData = localStorage.getItem('currentUser');
    const initialData = storedData ? JSON.parse(storedData) : null;
    this.userDataSubject = new BehaviorSubject<any>(initialData);
  }

  // Create a document
  create(collectionName: string, data: any): Promise<DocumentReference<any>> {
    return this.firestore.collection(collectionName).add(data);
  }

  // Get all documents in a collection
  list(collectionName: string): Observable<any[]> {
    return this.firestore.collection(collectionName).valueChanges();
  }

  // Service code
  getById(collectionName: string, documentId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const observable = this.firestore.collection(collectionName).doc(documentId).snapshotChanges();
      const subscription = observable.subscribe({
        next: (doc: any) => {
          if (doc.payload.exists) {
            resolve(doc.payload.data());
          } else {
            reject(new Error("Document not found"));
          }
        },
        error: (error: any) => {
          reject(error);
        },
        complete: () => {
          subscription.unsubscribe();
        }
      });
    });
  }
  getDocumentById(collectionName: string, documentId: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.firestore.collection(collectionName).doc(documentId).get().toPromise()
        .then((doc) => {
          if (doc.exists) {
            resolve(doc.data());
          } else {
            reject("Document not found");
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  // Update a document
  update(collectionName: string, documentId: string, data: any): Promise<void> {
    return this.firestore.collection(collectionName).doc(documentId).update(data);
  }



  updateField(collectionName: string, docId: string, fieldName: string, value: any) {
    return this.firestore.collection(collectionName).doc(docId).update({
      [fieldName]: value
    });
  }
  convertToServerTimestamp(date: Date): firebase.firestore.Timestamp {
    const firebaseTimestamp = firebase.firestore.Timestamp.fromDate(date);
    return firebaseTimestamp;
  }

  getFieldValueByModelId(productId: string, id: string, modelId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.firestore.collection('products', ref =>
        ref.where('productId', '==', productId)
          .where('id', '==', id)
      ).valueChanges().pipe(
        map((product: any) => {
          if (product && Array.isArray(product[0].modelDet)) {
            // Find the array within modelDet that matches the given modelId
            const modelArray = product[0].modelDet.find((model: any) => model.modelId === modelId);
            // If modelArray is found, extract the desired field value
            if (modelArray) {
              resolve(modelArray["availableQty"]);
            } else {
              resolve(null); // Resolve with null if modelId is not found
            }
          } else {
            resolve(null); // Resolve with null if product, modelDet, or modelDet is not found or not an array
          }
        })
      ).subscribe(() => { }, reject); // Subscribe to handle errors
    });
  }

  isOrderWithinDateRange(order: any, fromDate: Date, toDate: Date): boolean {
    const orderFromDate = (order.booking_start_date).toDate();
    const orderToDate = (order.booking_end_date).toDate();
    return ((fromDate >= orderFromDate && fromDate < orderToDate) || (toDate > orderFromDate && toDate <= orderToDate));
  }

  // getProductAvailability(modelId: string, productId: string, id: string, fromDate: Date, toDate: Date): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     this.firestore.collection('orderDetails', ref =>
  //       ref.where('payment_status', '==', 'paid')
  //         .where('product_Id', '==', productId)
  //     ).valueChanges().pipe(
  //       map((orders: any[]) => {
  //         let totalBookedQty = 0;
  //         if (orders.length > 0) {
  //           orders.forEach(order => {
  //             if (this.isOrderWithinDateRange(order, fromDate, toDate)) {
  //               // Iterate over each booking and check if any of its productIds arrays contain the productId
  //               if (Array.isArray(order.product_model)) {
  //                 if (order.product_model.some(item => item.modelId === modelId)) {
  //                   totalBookedQty += 1;
  //                 }
  //               }
  //             }
  //           });
  //         }
  //         // For simplicity, assuming product quantity is stored elsewhere, adapt as necessary
  //         // Here you should fetch the total available quantity of the product from your products collection
  //         // Example total available quantity, replace with actual logic
  //         var totalAvailableQty;
  //         try {
  //           this.firestore.collection('products', ref =>
  //             ref.where('productId', '==', productId)
  //               .where('id', '==', id)
  //           ).valueChanges().pipe(
  //             map((product: any) => {
  //               if (product && Array.isArray(product[0].modelDet)) {
  //                 // Find the array within modelDet that matches the given modelId
  //                 const modelArray = product[0].modelDet.find((model: any) => model.modelId === modelId);
  //                 // If modelArray is found, extract the desired field value
  //                 if (modelArray) {
  //                   totalAvailableQty = modelArray["availableQty"];
  //                   const remainingQty = Number(totalAvailableQty) - Number(totalBookedQty);
  //                   resolve(remainingQty);
  //                 } else {
  //                   resolve(null); // Resolve with null if modelId is not found
  //                 }
  //               } else {
  //                 resolve(null); // Resolve with null if product, modelDet, or modelDet is not found or not an array
  //               }
  //             })
  //           ).subscribe(() => { }, reject);

  //         } catch (error) {
  //           reject(error);
  //         }
  //       })
  //     ).subscribe(() => { }, reject); // Subscribe to handle errors
  //   });
  // }

  getProductAvailableQty(itemId: string, productId, startDate: Date, endDate: Date): Promise<number> {
    return new Promise((resolve, reject) => {
      this.firestore.collection('products', ref =>
        ref.where('productId', '==', productId)
          .where('id', '==', itemId)
      ).valueChanges().pipe(
        map((product: any) => {
          if (product && Array.isArray(product)) {
            // Find the array within modelDet that matches the given modelId
            const modelObject = product[0]
            // If modelArray is found, extract the desired field value
            if (modelObject) {
              const totalQuantity = modelObject["availableQty"]
              const bookedQuantity = product[0].bookings.reduce((acc, booking) => {
                if (booking.booking_start_date.toDate() < endDate && booking.booking_end_date.toDate() > startDate) {
                  let endDateAddedOnehour= booking.booking_end_date.toDate()
                  endDateAddedOnehour.setHours(endDateAddedOnehour.getHours() + 1);
                  // Booking overlaps with search range
                  const bookingStart = booking.booking_start_date.toDate() < startDate ? startDate : booking.booking_start_date.toDate();
                  const bookingEnd = endDateAddedOnehour > endDate ? endDate : endDateAddedOnehour;
                  const duration = bookingEnd.getTime() - bookingStart.getTime();
                  const daysBooked = Math.ceil(duration / (1000 * 3600 * 24));
                  return acc + daysBooked;
                }
                return acc;
              }, 0);
              const availableQuantity = totalQuantity - bookedQuantity;
              resolve(availableQuantity);
            } else {
              resolve(null); // Resolve with null if modelId is not found
            }
          } else {
            resolve(null); // Resolve with null if product, modelDet, or modelDet is not found or not an array
          }
        })
      ).subscribe(() => { }, reject);
    });
  }

  getAvailableQuantity(itemId: string, productId, startDate: Date, endDate: Date, modelId: any): Promise<number> {
    return new Promise((resolve, reject) => {
      this.firestore.collection('products', ref =>
        ref.where('productId', '==', productId)
          .where('id', '==', itemId)
      ).valueChanges().pipe(
        map((product: any) => {
          if (product && Array.isArray(product[0].modelDet)) {
            // Find the array within modelDet that matches the given modelId
            const modelArray = product[0].modelDet.find((model: any) => model.modelId === modelId);
            // If modelArray is found, extract the desired field value
            if (modelArray) {
              const totalQuantity = modelArray["availableQty"]
              const bookedQuantity = product[0].bookings.reduce((acc, booking) => {
                if (booking.booking_start_date.toDate() < endDate && booking.booking_end_date.toDate() > startDate) {
                  let endDateAddedOnehour= booking.booking_end_date.toDate()
                  endDateAddedOnehour.setHours(endDateAddedOnehour.getHours() + 1);
                  // Booking overlaps with search range
                  const bookingStart = booking.booking_start_date.toDate() < startDate ? startDate : booking.booking_start_date.toDate();
                  const bookingEnd = endDateAddedOnehour > endDate ? endDate : endDateAddedOnehour;
                  const duration = bookingEnd.getTime() - bookingStart.getTime();
                  const daysBooked = Math.ceil(duration / (1000 * 3600 * 24));
                  return acc + daysBooked;
                }
                return acc;
              }, 0);
              const availableQuantity = totalQuantity - bookedQuantity;
              resolve(availableQuantity);
            } else {
              resolve(null); // Resolve with null if modelId is not found
            }
          } else {
            resolve(null); // Resolve with null if product, modelDet, or modelDet is not found or not an array
          }
        })
      ).subscribe(() => { }, reject);
    });
  }
  // Update a document
  createwithUid(collectionName: string, uid: string, data: any): Promise<void> {
    return this.firestore.collection(collectionName).doc(uid).set(data);
  }
  sendEmail(emailData: { to: string, subject: string, text: string }): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/send-email`, emailData);
  }
  get nativeWindow(): any {
    return _window();
  }

  // Delete a document
  delete(collectionName: string, documentId: string): Promise<void> {
    return this.firestore.collection(collectionName).doc(documentId).delete();
  }

  createOrder(amount: number): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/create-order`, { amount });
  }

  updatePassword(email: string,newPassword:string): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/updatePassword`, { email,newPassword});
  }


  emailExists(email: string): Observable<boolean> {
    return this.firestore.collection('customer', ref => ref.where('email', '==', email)).get().pipe(
      switchMap(userSnapshot => {
        if (!userSnapshot.empty) {
          return of(true); // Email found in 'users' collection
        } else {
          return this.firestore.collection('Admin', ref => ref.where('email', '==', email)).get().pipe(
            map(adminSnapshot => !adminSnapshot.empty) // Check if email exists in 'admins' collection
          );
        }
      })
    );
  }
  phoneExists(mobile: string): Observable<boolean> {
    return this.firestore.collection('customer', ref => ref.where('mobile', '==', mobile)).get().pipe(
      switchMap(userSnapshot => {
        if (!userSnapshot.empty) {
          return of(true); // Phone found in 'users' collection
        } else {
          return this.firestore.collection('Admin', ref => ref.where('mobile', '==', mobile)).get().pipe(
            map(adminSnapshot => !adminSnapshot.empty) // Check if phone exists in 'admins' collection
          );
        }
      })
    );
  }

  getLoginDetailFromLocalStorage(): Observable<any> {
    const localStorageArray = localStorage.getItem('currentUser');
    if (localStorageArray) {
      const data = JSON.parse(localStorageArray);
      return of(data); // Wrapping the data in `of` to create an Observable
    } else {
      return of(null); // Return an Observable with null if no data found
    }
  }
  isUIDAvailable(uid: string, collectionName: string): Observable<boolean> {
    return this.firestore.collection(collectionName).doc(uid).valueChanges()
      .pipe(
        take(1),
        switchMap(document => {
          return of(document ? false : true);
        })
      );
  }

  generateUniqueID(): string {
    return uuidv4();
  }

  getOrderDetail(orderId: string): Promise<any> {
    return this.http.get<any>(`${environment.apiUrl}/payment-status/${orderId}`).toPromise();
  }

  getPaymentDetail(paymentId: string): Promise<any> {
    return this.http.get<any>(`${environment.apiUrl}/payment-details/${paymentId}`).toPromise();
  }


  // // Function to update a specific array within the inner array of a document
  // updateSpecificArray(collectionName: string, documentId: string, innerArrayIndex: number, innerArrayFieldName: string, newArray: any[]): Promise<void> {
  //   return new Promise<void>((resolve, reject) => {
  //     const documentRef = this.firestore.collection(collectionName).doc(documentId);

  //     // Get the document
  //     documentRef.get().subscribe((doc) => {
  //       if (doc.exists) {
  //         var array = doc.data() as any;
  //         var innerArray;
  //         if (array.hasOwnProperty(innerArrayFieldName)) {
  //           innerArray = array[innerArrayFieldName];
  //         } else {
  //           throw new Error(`Field ${innerArrayFieldName} not found in document`);
  //         }
  //         // Update the specific array within the inner array
  //         innerArray[innerArrayIndex] = newArray;

  //         const updateObject = {};
  //         updateObject[innerArrayFieldName] = innerArray;

  //         // Update the document with the modified inner array
  //         documentRef.update(updateObject)
  //           .then(() => {
  //             console.log("Specific array updated successfully");
  //             resolve();
  //           })
  //           .catch((error) => {
  //             console.error("Error updating specific array: ", error);
  //             reject(error);
  //           });
  //       } else {
  //         console.error("Document does not exist");
  //         reject("Document does not exist");
  //       }
  //     });
  //   });
  // }


  updateProductBooking(itemId: string, updateData: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const docRef = this.firestore.collection('products').doc(itemId);

      docRef.get().toPromise()
        .then(doc => {
          if (!doc.exists) {
            throw new Error('Document does not exist');
          }
          const docData = doc.data() as any;
          if (docData.hasOwnProperty('bookings')) {
            const modelArray = docData.bookings.find((e: any) => e.booking_id === updateData.booking_id);
            modelArray.booking_end_date = updateData.booking_end_date
            modelArray.booking_start_date = updateData.booking_start_date
            modelArray.locationDet = updateData.locationDet
            modelArray.booking_date = updateData.booking_date
            modelArray.pickup_time = updateData.pickup_time
            modelArray.created_date = updateData.created_date
            modelArray.total_amount = updateData.total_amount
            const filterArray = docData.bookings.filter((b: any) => b.booking_id !== updateData.booking_id);
            // Append bookingData to existing bookings array
            var existingBookings = [];
            existingBookings.push(modelArray);
            existingBookings.push(filterArray);
            const flattenedBookings = [].concat.apply([], existingBookings);
            return docRef.update({ bookings: flattenedBookings });
          }
        })
        .then(() => {
          console.log('Booking Updated successfully');
          resolve('Booking added successfully');
        })
        .catch(error => {
          console.error('Error adding booking:', error);
          reject(error);
        });
    });
  }




  placeOrder(itemId: string, bookingData: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const docRef = this.firestore.collection('products').doc(itemId);

      docRef.get().toPromise()
        .then(doc => {
          if (!doc.exists) {
            throw new Error('Document does not exist');
          }
          const docData = doc.data() as any;
          if (docData.hasOwnProperty('bookings')) {
            // Append bookingData to existing bookings array
            var existingBookings = [];
            existingBookings.push(bookingData);
            existingBookings.push(docData.bookings);
            const flattenedBookings = [].concat.apply([], existingBookings);
            return docRef.update({ bookings: flattenedBookings });
          }
        })
        .then(() => {
          console.log('Booking added successfully');
          resolve('Booking added successfully');
        })
        .catch(error => {
          console.error('Error adding booking:', error);
          reject(error);
        });
    });
  }

  cancelOrder(itemId: string, bookingData: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.firestore.collection('products').doc(itemId).get().toPromise()
        .then((doc) => {
          if (doc.exists) {
            var docData = doc.data() as any;
            const bookingsArray = docData.bookings || [];
            const updatedBookings = bookingsArray.filter((booking: any) =>
              booking.booking_id !== bookingData.booking_id
            );
            return this.firestore.collection('products').doc(itemId).update({ bookings: updatedBookings });
          } else {
            throw new Error('Document not found');
          }
        })
        .then(() => {
          console.log('Order canceled successfully');
          resolve('Order canceled successfully');
        })
        .catch((error) => {
          console.error('Error canceling order:', error);
          reject(error);
        });
    });
  }

  getOrders(): Observable<any> {
    return this.firestore.collection<any>('orderDetails', ref => ref.orderBy('created_date', 'desc'))
      .snapshotChanges()
      .pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data();
          const id = a.payload.doc.id;
          return {
            id,
            ...data
          };
        }))
      );
  }


  isTimeRangeAvailable(item: any, startTime: Date, endTime: Date): boolean {
    return !item.bookings.some(booking =>
      (startTime >= booking.startTime.toDate() && startTime < booking.endTime.toDate()) ||
      (endTime > booking.startTime.toDate() && endTime <= booking.endTime.toDate()));
  }



  updatePhoneNumber(oldPhoneNumber: string, newPhoneNumber: string): Observable<any> {
    // Update customer collection
    const updateCustomer = this.firestore.collection('customer', ref => ref.where('mobile', '==', oldPhoneNumber)).snapshotChanges().subscribe(customers => {
      customers.forEach(customer => {
        const customerId = customer.payload.doc.id;
        this.firestore.collection('customer').doc(customerId).update({ mobile: newPhoneNumber });
      });
      updateCustomer.unsubscribe();
    });

    // Update orders collection
    const updateOrders = this.firestore.collection('orderDetails', ref => ref.where('customer_phone', '==', oldPhoneNumber)).snapshotChanges().subscribe(orders => {
      orders.forEach(order => {
        const orderId = order.payload.doc.id;
        this.firestore.collection('orderDetails').doc(orderId).update({ customer_phone: newPhoneNumber });
      });
      updateOrders.unsubscribe();
    });

    // Update payment collection
    const updatePayment = this.firestore.collection('paymentDetails', ref => ref.where('customer_phone', '==', oldPhoneNumber)).snapshotChanges().subscribe(payments => {
      payments.forEach(payment => {
        const paymentId = payment.payload.doc.id;
        this.firestore.collection('paymentDetails').doc(paymentId).update({ customer_phone: newPhoneNumber });
      });
      updatePayment.unsubscribe();
    });

    // Update dupaymentdetails collection
    const updateDuPaymentDetails = this.firestore.collection('duePaymentDetails', ref => ref.where('customer_phone', '==', oldPhoneNumber)).snapshotChanges().subscribe(details => {
      details.forEach(detail => {
        const detailId = detail.payload.doc.id;
        this.firestore.collection('duePaymentDetails').doc(detailId).update({ customer_phone: newPhoneNumber });
      });
      updateDuPaymentDetails.unsubscribe();
    });

    // Update updateAdmin collection
    const updateAdmin = this.firestore.collection('Admin', ref => ref.where('mobile', '==', oldPhoneNumber)).snapshotChanges().subscribe(details => {
      details.forEach(detail => {
        const adminId = detail.payload.doc.id;
        this.firestore.collection('Admin').doc(adminId).update({ mobile: newPhoneNumber });
      });
      updateAdmin.unsubscribe();
    });

    // Return an observable indicating completion
    return new Observable(observer => {
      // You may want to add some logic to verify completion
      observer.next("Phone number updated successfully");
      observer.complete();
    });
  }

  updateEmail(uid: string, currentEmail: string, newEmail: string): Observable<string> {
    let successMessage = 'Email updated successfully.';
    let failureMessage = 'Failed to update email.';

    const httpUpdate$ = this.http.post<any>(`${environment.apiUrl}/update-email`, { uid, newEmail });
    const firestoreUpdate$ = this.updateFirestoreCollections(currentEmail, newEmail);

    return forkJoin([firestoreUpdate$, httpUpdate$]).pipe(
      switchMap(([firestoreResult, httpResult]) => {
        if (firestoreResult === successMessage && httpResult.message === "Email updated successfully") {
          return of(successMessage);
        } else {
          return of(failureMessage);
        }
      }),
      catchError(error => {
        console.error('Error updating email:', error);
        return of(failureMessage);
      }),
      finalize(() => {
        console.log('Update email operation completed.');
        return of("Update email operation completed");
      })
    );
  }



  updateFirestoreCollections(currentEmail: string, newEmail: string): Observable<string> {
    let successMessage = 'Email updated successfully.';
    let failureMessage = 'Failed to update email.';

    return this.firestore.collection('customer', ref => ref.where('email', '==', currentEmail))
      .get()
      .pipe(
        switchMap(customerSnapshot => {
          const customerBatch = this.firestore.firestore.batch();
          customerSnapshot.forEach(doc => {
            const customerRef = this.firestore.collection('customer').doc(doc.id).ref;
            customerBatch.update(customerRef, { email: newEmail });
          });

          return this.firestore.collection('orderDetails', ref => ref.where('customer_email', '==', currentEmail))
            .get()
            .pipe(
              switchMap(ordersSnapshot => {
                const ordersBatch = this.firestore.firestore.batch();
                ordersSnapshot.forEach(doc => {
                  const orderRef = this.firestore.collection('orderDetails').doc(doc.id).ref;
                  ordersBatch.update(orderRef, { customer_email: newEmail });
                });

                return this.firestore.collection('paymentDetails', ref => ref.where('customer_email', '==', currentEmail))
                  .get()
                  .pipe(
                    switchMap(paymentSnapshot => {
                      const paymentBatch = this.firestore.firestore.batch();
                      paymentSnapshot.forEach(doc => {
                        const paymentRef = this.firestore.collection('paymentDetails').doc(doc.id).ref;
                        paymentBatch.update(paymentRef, { customer_email: newEmail });
                      });

                      return this.firestore.collection('duePaymentDetails', ref => ref.where('customer_email', '==', currentEmail))
                        .get()
                        .pipe(
                          switchMap(dupaymentdetailsSnapshot => {
                            const dupaymentdetailsBatch = this.firestore.firestore.batch();
                            dupaymentdetailsSnapshot.forEach(doc => {
                              const dupaymentdetailsRef = this.firestore.collection('duePaymentDetails').doc(doc.id).ref;
                              dupaymentdetailsBatch.update(dupaymentdetailsRef, { customer_email: newEmail });
                            });


                            return this.firestore.collection('Admin', ref => ref.where('email', '==', currentEmail))
                              .get()
                              .pipe(
                                switchMap(adminSnapshot => {
                                  const adminBatch = this.firestore.firestore.batch();
                                  adminSnapshot.forEach(doc => {
                                    const adminRef = this.firestore.collection('Admin').doc(doc.id).ref;
                                    adminBatch.update(adminRef, { email: newEmail });
                                  });

                                  // Commit all batches
                                  return customerBatch.commit().then(() => ordersBatch.commit())
                                    .then(() => paymentBatch.commit()).then(() => dupaymentdetailsBatch.commit()).then(() => adminBatch.commit())
                                    .then(() => successMessage)
                                    .catch(error => {
                                      console.error('Error updating email:', error);
                                      throw error;
                                    });

                                })
                              );

                          })
                        );
                    })
                  );
              })
            );
        }),
        catchError(error => {
          console.error('Error updating email:', error);
          return of(failureMessage);
        }),
        finalize(() => {
          console.log('Update email operation completed.');
        })
      );
  }

  // generate order id

  async generateUniqueOrderId(): Promise<string> {
    let isUnique = false;
    let orderId = '';

    while (!isUnique) {
      orderId = this.generateOrderId();
      isUnique = await this.checkOrderIdExists(orderId);
    }

    return orderId;
  }

  private generateOrderId(): string {
    const prefix = 'order_';
    const randomString = this.generateRandomString(14); // Adjust the length as needed
    return `${prefix}${randomString}`;
  }

  private generateRandomString(length: number): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  private async checkOrderIdExists(orderId: string): Promise<boolean> {
    try {
      const docSnapshot = await this.firestore.collection('orderDetails').doc(orderId).get().toPromise();
      return !docSnapshot.exists;
    } catch (error) {
      console.error('Error checking order ID:', error);
      return false; // Handle error appropriately in your application
    }
  }
}


